/** @format */

export function hasPathNameChanged(pathName: string) {
    try {
        const { pathname, origin } = window.location;
        const newUrl = new URL(pathName, origin);

        return newUrl.pathname !== pathname;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, id-length, unicorn/catch-error-name -- Legacy code: do not use as an example.
    } catch (e) {
        return true;
    }
}
